import { List, Item as ListItem } from 'devextreme-react/list';
import { Component } from 'react';
import Inline from '../Inline';
import Body from '../ka-layout/Body';
import { apiGetP } from '../../GanjiTools';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import TestLoadOrder from './TestLoadOrder';
import TestLogon from './TestLogon';
import OrdersBoard from './OrdersBoard';
import LoadOrder from './LoadOrder';
import RegisterUser from './RegisterUser';
import SideDivider from '../layout/SideDivider';
import MasterLayout from '../layout/MasterLayout';
import MinimalButton from '../MinimalButton';
import Theme from '../theme/Theme';
import { BackgroundImage } from 'devextreme-react/range-selector';


class Home extends Component {
    state = {
        serverIsConnected: false,
        mode: this.props.mode ?? 'board',
        bodyKey: this.props.bodyKey ?? 1,
        key: 1,
    }

    // onClickBodySelector = item => {
    //     this.setState({ bodySid: item?.itemData?.sid })
    // }

    checkConnection = () => {
        console.log('check connection...');

        let onFailed = err => {
            window.setTimeout(this.checkConnection, 1000);
            window.onServerFailed('not_ok');
            window.onServerFailed?.(err);
        }

        apiGetP('/api/logon/checkConnection')
            .then(res => {
                let s = res?.resp ?? res;
                if (s != 'ok') {
                    onFailed('not_ok');
                    return;
                }

                window.clearTimeout();
                console.log('connection is ok.');
                this.setState({ serverIsConnected: true })
            })
            .catch(onFailed);
    }

    componentDidMount() {
        this.checkConnection();
    }

    render() {
        if (this.state.serverIsConnected !== true)
            return (
                <h2 style={{ direction: 'rtl', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'red' }}
                >
                    <FontAwesomeIcon icon='spinner' spin style={{ margin: '0 1rem' }} />
                    در انتظار پاسخ سرور ...
                </h2>
            );

        if (!this.props.innerBody && !this.state.mode || this.state.mode === 'logon' || !(window.user?.id > 0))
            return (
                <TestLogon onSuccessLogon={
                    user => {
                        console.log(user);
                        this.setState({ mode: 'board' });
                    }
                }
                />
            );

        console.log('Home: mode=', this.state.mode, ', status=', this.props.status, ', bodyKey=', this.state.bodyKey)

        let body = this.props.innerBody
            ?? this.state.mode === 'board'
            ?
            <OrdersBoard userRole={window.user?.role} userId={window.user?.idAtRole ?? 0} noUserName
                key={`ordersboard_${this.props.status ?? ''}_${this.state.bodyKey}`}
                userName={window.user?.userName}
                status={this.props.status ?? ''} statusName={this.props.statusName ?? ''}
                //userText={window.user?.fullname ?? '&nbsp;'}
                onEdit={(loadOrder, tempCol, enums, userRole) => {
                    SideDivider.forceHideSideMenu = true;
                    this.setState({
                        loadOrder, tempCol, mode: 'edit', bodyKey: this.state.bodyKey + 1, userRole, enums,
                    });
                }}
                onAddNewOrderClicked={() => {
                    SideDivider.forceHideSideMenu = true;
                    this.setState({
                        loadOrder: {}, tempCol: {}, mode: 'new', bodyKey: this.state.bodyKey + 1, userRole: 'orderer',
                    });
                }}

                onLogoff={() => {
                    window.user = { id: 0 };
                    this.setState({ mode: 'logon' });
                }}
            />
            : this.state.mode === 'edit'
                ?
                <LoadOrder loadOrder={this.state.loadOrder} userRole={this.state.userRole}
                    tempCol={this.state.tempCol}
                    wizardMode={window.config.LOADORDER_WIZARD_MODE === true}
                    key={'editmode_' + this.state.bodyKey}
                    onCancel={() => {
                        SideDivider.forceHideSideMenu = false;
                        this.setState({ mode: 'board', bodyKey: this.state.bodyKey + 1 })
                    }}
                />
                : this.state.mode === 'new'
                    ?
                    <LoadOrder id='new' userRole={this.state.userRole}
                        wizardMode={window.config.LOADORDER_WIZARD_MODE === true}
                        key={'newmode_' + this.state.bodyKey}
                        onCancel={() => {
                            SideDivider.forceHideSideMenu = false;
                            this.setState({ mode: 'board', bodyKey: this.state.bodyKey + 1 })
                        }}
                    />
                    : this.state.mode == 'demo'
                        ?
                        <TestLoadOrder />
                        :
                        <div>...</div>;

        return (
            <MasterLayout body={body} bodyKey={this.state.bodyKey} noTopMenu noUserIcon headerHeight={60}
                //containerStyle={{ backgroundImage: 'url(/images/logon.jpg)' }}
                headerFarItems={
                    <Inline spacing='0.5rem' style={{ height: '60px' }}>
                        <FontAwesomeIcon icon='palette' fontSize='1.2rem' hint='تغییر تم'
                            onClick={
                                () => {
                                    Theme.currThemeIndex = Theme.currThemeIndex < 0 ? 0 : -1;
                                    window.reload();
                                }}
                        />
                        <div id='user-name-banner'>
                            {/* {`${this.props.userName ?? this.state.userText ?? `${window.user?.role}-${window.user?.userName}`}`} */}
                            {`${window.user?.userName ?? ''} ${this.state.userText ?? ''}`}
                        </div>
                        <MinimalButton icon='fa-power-off' style={{ fontSize: '1.2em', width: '30px' }} highlightedColor='red'
                            onClick={() => {
                                window.user = { id: 0 };
                                this.setState({ mode: 'logon' });
                            }}
                        />
                    </Inline>
                }
                key={`masl_${this.state.key}_${this.state.bodyKey}_${this.props.status}`}
                headerNearItems={
                    [
                        <div style={{ width: '6rem', fontSize: '14px', fontWeight: '900' }}>تابلو بار عمومی</div>,
                        <div style={{ width: '6rem', fontSize: '14px', fontWeight: '900' }}>درباره ما</div>,
                        <div style={{ width: '6rem', fontSize: '14px', fontWeight: '900' }}>تماس با ما</div>
                    ]}
            />
        );
    }
}

export default Home;

/* 
    <MinimalButton rtlEnabled={true} height='100%' width='3rem' stylingMode='text'
        onClick={this.props.onUserIconClick}
    >
        <Inline>
            <span>
                {window.user?.fullname ?? window.user?.username ?? window.user?.name ?? '&npsp;'}
            </span>
            <FontAwesomeIcon icon='circle-user' beatFade fontSize='1.3rem' />
        </Inline>                        
    </MinimalButton>                 
*/